import {
  SUCCESS_TOAST,
  ERROR_TOAST,
  RESET_ERROR_TOAST,
  RESET_SUCCESS_TOAST,
  WARNING_TOAST,
  RESET_WARNING_TOAST,
} from "../../constants/action.constants";

const initialState = {
  errorToastObj: {},
  successToastObj: {},
  warningToastObj:{},
};

const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_TOAST:
      return { successToastObj: action.payload, errorToastObj: {} };
    case ERROR_TOAST:
      return { successToastObj: {}, errorToastObj: action.payload };
    case RESET_ERROR_TOAST:
      return { ...state, errorToastObj: {} };
      case RESET_SUCCESS_TOAST:
        return { ...state, successToastObj: {} };
        case WARNING_TOAST:
          return { ...state, warningToastObj: action.payload };
        case RESET_WARNING_TOAST:
          return { ...state, warningToastObj: {} };
    default:
      return state;
  }
};

export default toastReducer;
